if (!customElements.get("search-input")) {
	class SearchInput extends HTMLElement {
		constructor() {
			super();
		}

		get form() {
			return this.querySelector('.search-form');
		}

		get container() {
			return this.querySelector('.header__search');
		}

		get breakpoint() {
			const breakpoints = {
				tablet: 750,
				desktop: 990,
			}

			return breakpoints[this.getAttribute("breakpoint")] || breakpoints.tablet;
		}

		get finalWidth() {
			return Number(this.getAttribute("width") || "74.4");
		}

		get transitionDuration() {
			return Number(this.getAttribute("transition-duration") || "100");
		}

		isEnabled() {
			return matchMedia(`(min-width: ${this.breakpoint}px)`).matches;
		}

		animationOpen() {
			return new Promise(resolve => {
				this.container.style.width = `${this.finalWidth}rem`;
				this.container.style.left = `-${this.finalWidth - 4.4}rem`;
				this.form.classList.add("is-focused");
				this.setAttribute("active", '');
				document.body.setAttribute("style", "overflow-x: hidden")

				setTimeout(resolve, this.transitionDuration * 2)
			})
		}

		animationClose() {
			return new Promise(resolve => {
				this.container.removeAttribute("style");
				document.body.removeAttribute("style");
				this.form.classList.remove("is-focused");
				this.form.querySelector("input").blur();

				setTimeout(resolve, this.transitionDuration * 2)
			})
		}

		wait(time) {
			return new Promise(resolve => {
				setTimeout(resolve, time)
			})
		}

		async onMouseEnter() {
			if (this.isEnabled()) {
				await this.animationOpen();
				this.form.querySelector("input").focus();
				this.addEventListener("mouseleave", debounce(this.onMouseLeave.bind(this), 500), { once: true });
			}
		}

		async onMouseLeave() {
			if (this.isEnabled()) {
				await this.wait(this.transitionDuration);
				await this.animationClose();

				this.removeAttribute("active");
			}
		}

		connectedCallback() {
			this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
		}
	}

	customElements.define("search-input", SearchInput);
}